// extracted by mini-css-extract-plugin
export var divider = "_u6-0";
export var systemMessage = "_u6-1";